var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"share-section"},_vm._l((_vm.items),function(item,i){return _c('listItem',{key:item.spuId,attrs:{"item":item,"index":i},on:{"operation":_vm.refreshData}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }